














import Vue from 'vue';
import { ScheduleMsg, ScheduleMsgDisplayInfo, WxTpl } from '../../../models/ScheduleMsg';
import ScheduleTplMsgDisplay from './ScheduleTplMsgDisplay.vue';
import ScheduleCustomMsgDisplay from './ScheduleCustomMsgDisplay.vue';
import massClient from '@/mass/apis';
import { DelayMode } from '@/rule/models/ScheduleDelay';

export default Vue.extend({
  props: {
    eventDelayMode: {
      type: Number as () => DelayMode,
    },
    scheduleMsg: {
      type: Object as () => ScheduleMsg,
    },
    displayInfo: {
      type: Object as () => ScheduleMsgDisplayInfo,
    },
  },
  data() {
    return {
      remoteCardInfo: {},
      DelayMode,
    };
  },
  computed: {
    wxTpl(): WxTpl | null {
      return this.scheduleMsg && this.scheduleMsg.WxTpl;
    },
    wxTemplateId(): string | null {
      return this.wxTpl && this.wxTpl.templateId;
    },
    cardInfo(): any {
      return this.displayInfo.cardInfo  || this.remoteCardInfo;
    },
  },
  components: {
    ScheduleTplMsgDisplay,
    ScheduleCustomMsgDisplay,
  },
  mounted() {
    // 回填信息
    if(this.scheduleMsg) {
      const card = this.scheduleMsg && this.scheduleMsg.WxCard;
      if(card && card.cardId && (!this.displayInfo || !this.displayInfo.cardInfo)) { // 读取会员卡信息回填
        massClient.getCouponByCard({
          cardId: card.cardId,
        }).success((r: any) => {
          this.remoteCardInfo = r.coupon;
        });
      }
    }
  },
});
